/**
 * Recognized social/web link types (wire shape).
 * Mirrors the backend BookingPageLinkKind enum exactly (PascalCase strings).
 */
export type BookingPageLinkKind =
  | "Website"
  | "Instagram"
  | "Facebook"
  | "YouTube"
  | "LinkedIn"
  | "TikTok"
  | "WhatsApp"
  | "X";

export const BOOKING_PAGE_LINK_KINDS: BookingPageLinkKind[] = [
  "Website",
  "Instagram",
  "Facebook",
  "YouTube",
  "LinkedIn",
  "TikTok",
  "WhatsApp",
  "X",
];
